(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.headerIsAlwaysSticky = false;
    this.headerBounds = {};
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = ['always', 'reduce-logo-size'].includes(this.dataset.stickyType);
    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.onScrollHandler = this.onScroll.bind(this);
    this.onMouseEnterTop = this.onMouseEnterTop.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.addEventListener('preventHeaderReveal', () => this.preventReveal = true);
    this.createObserver();
    this.initMouseTopTrigger();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    document.removeEventListener('mousemove', this.onMouseEnterTop);
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  createObserver() {
    const observer = new IntersectionObserver(entries => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.headerIsAlwaysSticky && !this.preventHide) {
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.headerIsAlwaysSticky && !this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => this.preventReveal = false, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      if (!this.headerIsAlwaysSticky) {
        requestAnimationFrame(this.reset.bind(this));
      }
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  initMouseTopTrigger() {
    document.addEventListener('mousemove', this.onMouseEnterTop);
  }

  onMouseEnterTop(event) {
    if (event.clientY <= 5) {
      this.reveal();
    }
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-image-with-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.slider-image-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
